module.exports = __webpack_public_path__ + "images/emoji/smiley.a612a26eb30e97d3a4d4.png";